import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import _en from './translations/en.json.mjs';
import React from 'react';
import { Tabs } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import { autobind } from '../../packages/@web-utilities/decorators/index.mjs';
import styles from './TextColor.scss.mjs';
import { ColorPicker } from '../ColorPicker/ColorPicker.mjs';
import Presets from './components/Presets.mjs';
import compose from '@shopify/react-compose';

var _class;
let Tab = /*#__PURE__*/function (Tab) {
  Tab[Tab["TextColorTab"] = 0] = "TextColorTab";
  Tab[Tab["BackgroundColorTab"] = 1] = "BackgroundColorTab";
  return Tab;
}({});
let Picker = /*#__PURE__*/function (Picker) {
  Picker["TextColorPicker"] = "textColor";
  Picker["BackgroundColorPicker"] = "backgroundColor";
  return Picker;
}({});
const colorPresets = [{
  hue: 10,
  saturation: 1,
  brightness: 1,
  name: 'red'
}, {
  hue: 30,
  saturation: 1,
  brightness: 1,
  name: 'orange'
}, {
  hue: 60,
  saturation: 1,
  brightness: 1,
  name: 'yellow'
}, {
  hue: 90,
  saturation: 1,
  brightness: 1,
  name: 'green'
}, {
  hue: 200,
  saturation: 1,
  brightness: 1,
  name: 'light blue'
}, {
  hue: 250,
  saturation: 1,
  brightness: 1,
  name: 'dark blue'
}, {
  hue: 300,
  saturation: 1,
  brightness: 1,
  name: 'magenta'
}];
const shadePresets = [{
  hue: 0,
  saturation: 0,
  brightness: 0,
  name: 'black'
}, {
  hue: 0,
  saturation: 0,
  brightness: 0.25,
  name: 'darker grey'
}, {
  hue: 0,
  saturation: 0,
  brightness: 0.5,
  name: 'dark grey'
}, {
  hue: 0,
  saturation: 0,
  brightness: 0.7,
  name: 'medium grey'
}, {
  hue: 0,
  saturation: 0,
  brightness: 0.8,
  name: 'light grey'
}, {
  hue: 0,
  saturation: 0,
  brightness: 0.9,
  name: 'lighter grey'
}, {
  hue: 0,
  saturation: 0,
  brightness: 1,
  name: 'white'
}];
const DEFAULT_BLACK = {
  hue: 0,
  saturation: 0,
  brightness: 0
};
let TextColor = (_class = class TextColor extends React.PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      selectedTab: Tab.TextColorTab
    };
  }
  render() {
    const {
      i18n,
      textColor,
      backgroundColor
    } = this.props;
    const {
      selectedTab
    } = this.state;
    const activePicker = selectedTab === Tab.TextColorTab ? textColor : backgroundColor;
    const colorTabs = [{
      id: Picker.TextColorPicker,
      content: i18n.translate('TextColor.text'),
      accessibilityLabel: i18n.translate('TextColor.textColor'),
      panelID: `${Picker.TextColorPicker}-panel`
    }, {
      id: Picker.BackgroundColorPicker,
      content: i18n.translate('TextColor.background'),
      accessibilityLabel: i18n.translate('TextColor.backgroundColor'),
      panelID: `${Picker.BackgroundColorPicker}-panel`
    }];
    return /*#__PURE__*/React.createElement("div", {
      className: styles.Container
    }, /*#__PURE__*/React.createElement(Tabs, {
      tabs: colorTabs,
      selected: selectedTab,
      onSelect: this.handleTabChange,
      fitted: true
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.Picker
    }, /*#__PURE__*/React.createElement(ColorPicker, {
      onChange: this.handleColorChange,
      color: activePicker ? activePicker : DEFAULT_BLACK
    })), /*#__PURE__*/React.createElement(Presets, {
      colors: colorPresets,
      onPresetClick: this.handlePresetClick,
      onPresetKeyDown: this.handlePresetKeyDown
    }), /*#__PURE__*/React.createElement(Presets, {
      colors: shadePresets,
      onPresetClick: this.handlePresetClick,
      onPresetKeyDown: this.handlePresetKeyDown
    })));
  }
  handlePresetClick(color) {
    const {
      onColorPresetSelection
    } = this.props;
    this.handleColorChange(color);
    onColorPresetSelection();
  }
  handlePresetKeyDown() {
    const {
      onColorPresetSelection
    } = this.props;
    onColorPresetSelection();
  }
  handleTabChange(selectedTab) {
    this.setState({
      selectedTab
    });
  }
  handleColorChange(color) {
    const {
      onTextChange,
      onBackgroundChange
    } = this.props;
    const {
      selectedTab
    } = this.state;
    const isTextColor = selectedTab === Tab.TextColorTab;
    const isBackgroundColor = selectedTab === Tab.BackgroundColorTab;
    if (isTextColor) {
      onTextChange(color);
      return;
    }
    if (isBackgroundColor) {
      onBackgroundChange(color);
    }
  }
}, (_applyDecoratedDescriptor(_class.prototype, "handlePresetClick", [autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handlePresetClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handlePresetKeyDown", [autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handlePresetKeyDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleTabChange", [autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleTabChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleColorChange", [autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleColorChange"), _class.prototype)), _class);
var TextColor$1 = compose(withI18n({
  id: 'TextColor_jqn5ac',
  fallback: _en,
  translations(locale) {
    if (["cs", "da", "de", "es", "fi", "fr", "it", "ja", "ko", "nb", "nl", "pl", "pt-BR", "pt-PT", "sv", "th", "tr", "vi", "zh-CN", "zh-TW"].indexOf(locale) < 0) {
      return;
    }
    return import( /* webpackChunkName: "TextColor_jqn5ac-i18n", webpackMode: "lazy-once" */`./translations/${locale}.json`).then(dict => dict && dict.default);
  }
}))(TextColor);

export { Picker, Tab, colorPresets, TextColor$1 as default, shadePresets };
